import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import UploadReverificationSheetModal from '../../../../components/Modal/UploadReverificationSheet.modal'
import ExamService from '../../../../services/exam.service'
import toast from 'react-hot-toast';

interface IReverificationDetailsProps {
    examId: any;
}

export default function ReverificationDetails({ examId }: IReverificationDetailsProps) {
    const [showUploadModal, setShowUploadModal] = useState<boolean>(false)
    const [showUploadStudentModal, setShowUploadStudentModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [userUploadActive, setUserUploadActive] = useState<boolean>(false);

    const handleUploadOperatorCSV = async (file: any) => {
        const formData = new FormData();
        formData.append('file', file);
        setLoading(true);
        await ExamService.uploadReverficationOperatorSheet(examId, formData).then((res: any) => {
            if (res.status === 200) {
                setShowUploadModal(false);
                setShowUploadStudentModal(false);
                setUserUploadActive(true);
            }
        }).catch((err: any) => {
            console.error(err);
            toast.error(err?.response?.data?.message || err?.response?.data || 'Failed to upload file');
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleUploadStudentCSV = async (file: any) => {
        const formData = new FormData();
        formData.append('file', file);
        setLoading(true);
        await ExamService.uploadReverficationUserSheet(examId, formData).then((res: any) => {
            if (res.status === 200) {
                setShowUploadModal(false);
                setShowUploadStudentModal(false);
            }
        }).catch((err: any) => {
            toast.error(err?.response?.data?.message || err?.response?.data || 'Failed to upload file');
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <>
            <div>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                    <h5>Re-Verification Settings</h5>
                    <div className='d-flex gap-2'>
                        <Button onClick={() => setShowUploadModal(true)}>Upload Operator CSV</Button>
                        <Button onClick={() => setShowUploadStudentModal(true)}>Upload Student CSV</Button>
                    </div>
                </div>
            </div>

            <UploadReverificationSheetModal
                show={showUploadModal}
                handleClose={() => setShowUploadModal(false)}
                onUploadSuccess={handleUploadOperatorCSV}
                uploading={loading}
            />

            <UploadReverificationSheetModal
                show={showUploadStudentModal}
                handleClose={() => setShowUploadStudentModal(false)}
                onUploadSuccess={handleUploadStudentCSV}
                uploading={loading}
            />
        </>
    )
}
